export const PROGRAMS = "PROGRAMS";
export const PROGRAMS_ARE_LOADING = "PROGRAMS_ARE_LOADING";
export const PROGRAMS_DEGREES = "PROGRAMS_DEGREES";
export const PROGRAMS_DEGREES_LOADING = "PROGRAMS_DEGREES_LOADING";
export const PROGRAM = "PROGRAM";
export const PROGRAM_LOADED = "PROGRAM_LOADED";
